import { Store } from 'pullstate'

const FormsStore = new Store({ });

export default FormsStore;